import styled, { css } from "styled-components";

interface ItemActiveProps {
  active: boolean;
}

export const BottomNavItemBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const BottomNavItem = styled.div<ItemActiveProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${(props) =>
    props.active &&
    css`
      background: ${(props) => props.theme.colors.whiteActive};
      color: ${(props) => props.theme.colors.primary};
      font-weight: 600;

      svg {
        path {
          fill: ${(props) => props.theme.colors.primary};
        }
      }
    `}

  &:active {
    background: ${(props) => props.theme.colors.whiteActive};
    color: ${(props) => props.theme.colors.primary};
    font-weight: 600;

    svg {
      path {
        fill: ${(props) => props.theme.colors.primary};
      }
    }
  }
`;

export const NavItemIcon = styled.div`
  margin-left: 5px;
  svg {
    width: 30px;
    height: 26px;
  }
`;

export const NavItemTit = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 15px;
`;

export const NavItemLine = styled.div`
  span {
    font-size: 1.8rem;
    font-weight: 500;
    text-align: right;
  }
`;

export const NavItemLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding: 6px;
`;

export const NavItemBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
